export default __webpack_public_path__ + "static/media/card-project5.672efa16.jpg";